import $ from "jquery";

(function($) {
    let galleryOptions = {
        rel:'gal',
        width: '95%',
        height: '95%',
        maxWidth: '960px',
        maxHeight: '700px',
        top: '15%',
        iframe: true,
        href: function(){
            var videoId = new RegExp('[\\?&]v=([^&#]*)').exec(this.href);
            if (videoId && videoId[1]) {
                return 'https://youtube.com/embed/'+videoId[1]+'?rel=0&wmode=transparent';
            }
        }   
    }
    function popUpVideos(){
        let $popup = $('a.expertise-video').colorbox(galleryOptions);
        return $popup;
    }
    function resizeGallery($popup) {
        $popup.colorbox.resize({
            width: window.innerWidth > parseInt(galleryOptions.maxWidth) ? galleryOptions.maxWidth : galleryOptions.width,
            height: window.innerHeight > parseInt(galleryOptions.maxHeight) ? galleryOptions.maxHeight : galleryOptions.height
        });
    }
    $(window).on('load', function() {
        popUpVideos();
    });
    $(window).bind('resize', function() {
        resizeGallery(popUpVideos());
    });
})(jQuery);